/** Display label for a stored customer type: 'credit' → 'Credit'. The value is
 *  persisted lowercase and compared lowercase; only the visible text is cased. */
export function customerTypeLabel(type: string | null | undefined): string {
  if (!type) return '—';
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
}
